import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { SimplePhone } from '../../components/SimplePhone';
import { getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { ISeller } from '../../types/newbuilding/seller';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { trackShowPhone } from '../Builder/tracking';
import { BuilderChatButtonContainer } from '../BuilderChatButton';

interface IContactsContainerProps {
  seller: ISeller;
}

export function ContactsContainer({ seller }: IContactsContainerProps) {
  const gaLabel = useSelector(getGaLabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const hasPhone = seller.phone && seller.phone.number;
  const hasChat = seller.chat?.isEnabled && seller.realtyUserId;

  const chatContacts = React.useMemo(() => {
    return {
      builders: [],
      sellers: [seller],
    };
  }, [seller]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'agentBlock';

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: false,
    });
  }, [gaLabel, newbuildingId]);

  if (!hasPhone && !hasChat) {
    return null;
  }

  return (
    <>
      {hasPhone && (
        <SimpleCall
          builders={[]}
          sellers={[seller]}
          onShowPhoneClick={onShowPhoneClick}
          openContactsStyles={{ size: 'M' as const }}
          showPhoneStyles={{
            size: 'M' as const,
            beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
          }}
          SinglePhoneComponent={SimplePhone}
          httpApi={httpApi}
          logger={logger}
          pageType={pageType}
          platformType={platformType}
          placeType={placeType}
          singlePhoneButtonText="Показать телефон"
        />
      )}
      {hasChat && <BuilderChatButtonContainer forcedContacts={chatContacts} />}
    </>
  );
}
